<div class="bg-white rounded-lg shadow-lg flex flex-col justify-between mx-auto  p-6">
    <div *ngIf="cartSummary && cartSummary.total_items" class="cart-summary flex flex-col justify-start space-y-4">

        <!-- Header -->
        <div class="border-b pb-3">
            <h3 class="text-xl font-bold text-gray-800">Price Summary</h3>
        </div>

        <div>
            <p class="text-xl my-2 text-center antialiased text-black font-bold">
                Choose Payment Method
            </p>

            <div class="p-2 grid grid-cols-1 md:grid-cols-2 gap-2">
                <!-- Online -->
                <div (click)="changePaymentMode('P')"
                    class="flex items-center justify-between text-start py-4 cursor-pointer px-2 rounded-lg w-full gap-2"
                    [ngClass]="{
        'border-2 border-primary': paymentMode === 'P',
        'border border-gray-200': paymentMode !== 'P'
      }">
                    <div>
                        <p-radioButton name="paymentMode" value="P" [(ngModel)]="paymentMode"
                            inputId="paymentOnline"></p-radioButton>
                        <label for="paymentOnline" class="ml-2">Online</label>
                    </div>
                    <p class="text-sm relative payment-methods">
                        <span class="animate-gradient">UPI | Cards | Netbanking</span>
                    </p>

                </div>

                <!-- COD -->
                <div (click)="changePaymentMode('C')"
                    class="flex items-center text-start py-4 px-2 rounded-lg w-full gap-2 cursor-pointer" [ngClass]="{
        'border-2 border-primary': paymentMode === 'C',
        'border border-gray-200': paymentMode !== 'C'
      }">
                    <p-radioButton name="paymentMode" value="C" [(ngModel)]="paymentMode"
                        inputId="paymentCod"></p-radioButton>
                    <label for="paymentCod" class="ml-2">COD</label>
                </div>
            </div>
        </div>

        <!-- Cart Items Count -->
        <div class="flex justify-between items-center">
            <p class="text-gray-600">Items in Cart</p>
            <span class="bg-primary text-white font-medium px-3 py-1 rounded-full">
                {{cartSummary.total_items}}
            </span>
        </div>

        <!-- Price Details Section -->
        <div class="space-y-3">
            <p class="text-sm font-medium text-gray-500 uppercase tracking-wider">Price Details</p>

            <div class="flex justify-between items-center">
                <p class="text-gray-600">Total MRP:</p>
                <p class="text-gray-800 font-medium">₹{{cartSummary.subtotal | number}}</p>
            </div>

            <div class="flex justify-between items-center">
                <p class="text-gray-600">Discount on MRP:</p>
                <p class="text-gray-800 font-medium">₹{{((cartSummary?.totalDiscount || 0) - (cartSummary?.discount || 0
                    )) |
                    number}}
                </p>
            </div>

            <div class="flex justify-between items-center">
                <p class="text-gray-600">Coupon Discount:</p>
                <p class="text-gray-800 font-medium">₹ 0
                </p>
            </div>

            <div class="flex justify-between items-center">
                <p class="text-gray-600">Shipping:</p>
                <p class="text-gray-800 font-medium" *ngIf="cartSummary.shippingCost > 0">₹{{cartSummary.shippingCost}}
                </p>
                <p class="text-gray-800 font-medium text-primary" *ngIf="cartSummary.shippingCost < 1">0.0 (Free)</p>

            </div>

            <div class="flex justify-between items-center">
                <p class="text-gray-600">GST & Taxes (Inclusive)</p>
                <p class="text-gray-800 font-medium"> ₹{{cartSummary.tax | number}}</p>
            </div>
        </div>

        <!-- Divider -->
        <div class="border-t border-dashed border-gray-300 my-2"></div>

        <div *ngIf="paymentMode=='P'" class="flex justify-between items-center">
            <p class="text-primary font-bold">10% Discount on Prepaid Orders</p>
            <p class="text-primary font-bold ">- ₹{{cartSummary?.discount | number}}</p>
        </div>

        <div class="border-t border-dashed border-gray-300 my-2"></div>


        <!-- Divider -->
        <!-- <div class="border-t border-primary my-2"></div> -->

        <!-- Total -->
        <div class="flex justify-between items-center pt-2">
            <p class="text-lg font-bold text-gray-800">Total</p>
            <p class="text-xl font-bold text-gray-800">₹{{cartSummary.total | number}}</p>
        </div>

        <!-- Discount Section -->
        <div class="text-center ">
            <div class="flex justify-center text-center text-secondary font-bold px-5 py-2">
                <p class=" text-center font-medium text-lg">You Save Total ₹{{cartSummary.totalDiscount | number}}</p>
            </div>
        </div>
        <div class="border-t border-primary my-2"></div>

    </div>
</div>